import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ContentContainer from '../../components/common/ContentContainer/ContentContainer';
import Panel from '../../components/common/Panel/Panel';
import { LoginForm, LoginFormValues } from '../../components/authentication/LoginForm/LoginForm';
import styles from './LoginPage.module.css';
import { useAuth } from '../../app/auth/AuthContext';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>('');

  const handleSubmit = async (values: LoginFormValues) => {
    setIsLoading(true);
    setError('');

    const credentials = {
      username: values.username,
      password: values.password,
    };

    const result = await login(credentials);

    if (result.success) {
      const returnPath = searchParams.get('returnPath') || '/';
      navigate(returnPath);
    } else {
      setError(result.error || 'Inloggen mislukt');
    }

    setIsLoading(false);
  };

  return (
    <ContentContainer>
      <div className={styles.loginContainer}>
        <div className={styles.logoSection}>
          <h1 className={styles.logo}>Codey</h1>
          <p className={styles.subtitle}>Leer programmeren op een leuke manier</p>
        </div>

        <Panel className={styles.loginPanel}>
          <LoginForm onSubmit={handleSubmit} isLoading={isLoading} error={error} />
        </Panel>
      </div>
    </ContentContainer>
  );
};

export default LoginPage;
